import {module} from 'modujs';

export default class extends module {
  constructor(m) {
    super(m);

    this.style = {
      active: '#FEF6F4'
    }
    this.items = this.el.querySelectorAll('.repeaterFAQ-item')
  }

  init() {
    let self = this;

    self.items.forEach(item => {
      item.addEventListener('click', () => {
        console.log('open')
        self.toggle(item)
      })
    })
  }

  toggle(item) {
    if (!item.classList.contains('active')) {
      this.open(item)
    } else this.close(item)
  }

  open(item) {
    item.classList.add('active')
  }

  close(item) {
    item.classList.remove('active')
  }

  destroy() {
    console.log('Destroy Filter 💥✅')
    this.items.forEach(el => {
      el.removeEventListener('click', this)
    })
  }
}





// WEBPACK FOOTER //
// ./scripts/modules/repeaterFAQ.js